import { isEmpty } from 'lodash';
import metaDatabaseHotelsReducer from './metaDatabse.hotels.reducer';
import metaDatabaseHotelPromotionsReducer from './metaDatabse.hotelPromotions.reducer';
import metaDatabaseDestinationsReducer from './metaDatabse.destinations.reducer';
import metaDatabaseRegionsReducer from './metaDatabse.regions.reducer';
import metaDatabaseHotelsReviewsReducer from './metaDatabse.hotelReviews.reducer';
import metaDatabaseMembersReducer from './metaDatabse.members.reducer';
import metaDatabaseMemberEmailsReducer from './metaDatabse.memberEmails.reducer';
import metaDatabaseRequestsReducer from './metaDatabse.requests.reducer';
import metaDatabaseReservationsReducer from './metaDatabse.reservations.reducer';
import metaDatabaseReservationHotelsReducer from './metaDatabse.reservationHotels.reducer';
import metaDatabaseTestimoniesReducer from './metaDatabse.testimonies.reducer';
import metaDatabaseUsersReducer from './metaDatabse.users.reducer';

const initialState = {
    // CRM DB
    hotels: {},
    hotelPromotions: {},
    destinations: {},
    regions: {},
    memberEmails: {},
    members: {},
    requests: {},
    reservations: {},
    reservationHotels: {},
    users: {},

    // Local DB
    hotelReviews: {},
    testimonies: {},
};

export default function (st, action)
{
    const state = isEmpty(st) ? initialState : st;

    // CRM DB
    state.hotels = metaDatabaseHotelsReducer(state.hotels, action);
    state.hotelPromotions = metaDatabaseHotelPromotionsReducer(state.hotelPromotions, action);
    state.destinations = metaDatabaseDestinationsReducer(state.destinations, action);
    state.regions = metaDatabaseRegionsReducer(state.regions, action);
    state.memberEmails = metaDatabaseMemberEmailsReducer(state.memberEmails, action);
    state.members = metaDatabaseMembersReducer(state.members, action);
    state.requests = metaDatabaseRequestsReducer(state.requests, action);
    state.reservations = metaDatabaseReservationsReducer(state.reservations, action);
    state.reservationHotels = metaDatabaseReservationHotelsReducer(state.reservationHotels, action);
    state.users = metaDatabaseUsersReducer(state.users, action);

    // Local DB
    state.hotelReviews = metaDatabaseHotelsReviewsReducer(state.hotelReviews, action);
    state.testimonies = metaDatabaseTestimoniesReducer(state.testimonies, action);

    return state;
}
